export default __webpack_public_path__ + "static/media/horror.e4ad94ad.png";